import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/phone-blue.svg")